import { Pressable, ScrollView, View } from "react-native";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceText } from "../components/PlaceText";
import { BasePage } from "../helpers/BasePage";
import { PlaceColors } from "../helpers/PlaceColors";
import { FindifySimpleHeader } from "../components/FindifySimpleHeader";
import Icon from "react-native-vector-icons/Ionicons";
import { LoginApi } from "../../../findifyv2-api-ts/users/login/LoginApi";
import { FindifyToast } from "../components/FindifyToast";
import { FindifyInputRendererType } from "../helpers/FindifyInputRender";
import { useForm } from "react-hook-form";
import { ProfileFormModal } from "../ProfileTab";
import { FindifyTopBarOverlay } from "../components/FindifyTopBarOverlay";

export const AdminZone = ({ navigation }: any) => {
    const { t } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    const loginApi = new LoginApi();
    const [authData, setAuthData] = useState<any>({});
    const [isLogged, setIsLogged] = useState(false);


    return (<BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <FindifySimpleHeader
            isEventLayout
            hideMenu={true}
            title={t('base.admin.admin_zone')}
            backgroundColor={PlaceColors(findifyDataContext).background.get()}
            navigation={navigation} />

        {!isLogged && <MakeAdminZoneAppsLoginZone
            findifyDataContext={findifyDataContext}
            navigation={navigation}
            authData={authData}
            setAuthData={setAuthData}
            isLogged={isLogged}
            setIsLogged={setIsLogged}
            loginApi={loginApi}
            t={t} />}
        {isLogged && <MakeAdminZoneAppsList
            findifyDataContext={findifyDataContext}
            authData={authData}
            setAuthData={setAuthData}
            isLogged={isLogged}
            setIsLogged={setIsLogged}
            loginApi={loginApi}
            navigation={navigation}
            t={t} />}

    </BasePage >);
};


const MakeAdminZoneAppsLoginZone = ({
    findifyDataContext,
    navigation,
    authData,
    setAuthData,
    isLogged,
    setIsLogged,
    t,
    loginApi
}: any) => {
    const form = useForm();
    const fields = [
        {
            label: t('profile_tab.login.email'),
            fieldKey: 'email',
            type: FindifyInputRendererType.Text,
            textContentType: "emailAddress",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3,
                maxLength: (v: string) => v?.length ?? 0 <= 250, //  "The email should have at most 50 characters",
                invalidEmail: (v: string) => /\S+@\S+\.\S+/.test(v ?? ''), //  "Email address must be a valid address",
            },
            required: true
        },
        {
            label: t('profile_tab.login.password'),
            fieldKey: 'password',
            textContentType: "password",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3
            },
            type: FindifyInputRendererType.Text,
            required: true
        },
    ]

    const actions = [
        {
            onPress: async () => {
                const valid = await form.trigger();
                if (valid) {
                    const data = form.getValues();
                    loginApi.login(
                        data.email,
                        data.password
                    ).then((res: any) => {
                        setAuthData(res);
                        setIsLogged(true);
                        FindifyToast({ type: 'success', title: t('profile_tab.login.login_successful') });
                    }).catch((err: any) => {
                        // Warn about invalid data
                        FindifyToast({ type: 'error', title: t('profile_tab.login.invalid_credentials') });
                    });
                }
            },
            label: t('profile_tab.login.login')
        }, // TODO IS RESET NEEDED IN APP??
        {
            onPress: () => {
                // GO back to previous page
                navigation.goBack();
            },
            label: t('profile_tab.login.close')
        }
    ];

    return <ProfileFormModal
        fields={fields}
        isOpen={true}
        setIsOpen={(newState: any) => {
            // console.log('newState', newState)
            // if (newState === false) {
            //     // GO back to previous page
            //     navigation.goBack();
            // }
        }}
        findifyDataContext={findifyDataContext}
        label={t('profile_tab.login.login')}
        form={form}
        t={t}
        actions={actions}
    />;
}

const MakeAdminZoneAppsList = ({
    findifyDataContext,
    navigation,
    t,
    authData,
    setAuthData,
    isLogged,
    setIsLogged,
    loginApi,


}: any) => {
    return <ScrollView
        bounces={false}
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
        style={{
            backgroundColor: PlaceColors(findifyDataContext).background.get(),
        }}
    >
        <MakeAdminZoneIcon authData={authData} navigation={navigation} icon="qr-code-outline" module={t('base.tickets.ticket_validation')} path="AdminTicketValidation" findifyDataContext={findifyDataContext} />
    </ScrollView >;
}

const MakeAdminZoneIcon = ({ navigation, module, icon, path, findifyDataContext, authData }: any) => {
    return <Pressable
        style={{
            display: 'flex',
            flexDirection: 'column',
            borderColor: PlaceColors(findifyDataContext).secondary.get(),
            borderRadius: 10,
            borderWidth: 1,
            padding: 10,
            gap: 6,
            marginHorizontal: 10,
            marginVertical: 4,
            alignItems: 'center',
        }}
        onPress={() => navigation.navigate(path, { 'authData': authData })}
    >
        <Icon
            name={icon}
            size={20}
            color={PlaceColors(findifyDataContext).text.get()}
        />
        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{module}</PlaceText>
    </Pressable>;
}
